import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import {
  Cookie,
  allCookiesSelected,
  cookies,
  cookieState,
  CookieKey
} from './cookies';
import { tss } from 'tss-react/mui';

import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CancelIcon from '@mui/icons-material/Cancel';
import Cookies from 'js-cookie';

interface Props {
  open: boolean;
  handleCookieSave: (cookies: cookieState) => void;
  onClose: () => void;
}

export const CookieSettingsModal: React.FC<Props> = ({
  open,
  onClose,
  handleCookieSave
}) => {
  const [cookiesAccordionState, setCookiesAccordionState] =
    useState(loadCookies);

  useEffect(() => {
    if (open) {
      setCookiesAccordionState(loadCookies());
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Privacy Settings</DialogTitle>
      <Divider />
      <DialogContent>
        <Typography>
          When you visit any website, it may store or retrieve information on
          your browser, mostly in the form of cookies. This information might be
          about you, your preferences or your device and is mostly used to make
          the site work as you expect it to. The information does not usually
          directly identify you, but it can give you a more personalized web
          experience. Because we respect your right to privacy, you can choose
          not to allow some types of cookies. Click on the different category
          headings to find out more and change our default settings. However,
          blocking some types of cookies may impact your experience of the site
          and the services we are able to offer.
        </Typography>
        <Button
          variant="contained"
          sx={theme => ({ my: theme.spacing(2) })}
          onClick={() => {
            handleCookieSave(allCookiesSelected);
            onClose();
          }}
        >
          Accept all
        </Button>
        <Typography variant="h6">Manage Consent Preferences</Typography>
        {cookies.map(cookie => (
          <CookieAccordion
            key={cookie.key}
            cookie={cookie}
            isSelected={cookiesAccordionState[cookie.key]}
            setIsSelected={() => {
              setCookiesAccordionState({
                ...cookiesAccordionState,
                [cookie.key]: !cookiesAccordionState[cookie.key]
              });
            }}
          />
        ))}
      </DialogContent>
      <Divider />
      <DialogActions sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          //save the cookies user has selected/diselected
          onClick={() => handleCookieSave(cookiesAccordionState)}
        >
          Confirm Selection
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const loadCookies = () => {
  return {
    cookie_targeting: Cookies.get(CookieKey.cookie_targeting) === '1',
    cookie_social_networks:
      Cookies.get(CookieKey.cookie_social_networks) === '1',
    cookie_functional: Cookies.get(CookieKey.cookie_functional) === '1',
    cookie_performance: Cookies.get(CookieKey.cookie_performance) === '1',
    cookie_necessary: true
  };
};

const CookieAccordion: React.FC<{
  cookie: Cookie;
  isSelected: boolean;
  setIsSelected: () => void;
}> = ({ cookie, isSelected, setIsSelected }) => {
  const { classes } = useStyles();
  return (
    <Accordion disableGutters>
      <AccordionSummary classes={{ content: classes.root }}>
        <Typography>+ {cookie.title}</Typography>
        {isSelected || cookie.key === 'cookie_necessary' ? (
          <CheckBoxIcon
            color="success"
            onClick={e => {
              e.stopPropagation();
              cookie.key !== 'cookie_necessary' && setIsSelected();
            }}
          />
        ) : (
          <CancelIcon
            color="error"
            onClick={e => {
              e.stopPropagation();
              setIsSelected();
            }}
          />
        )}
      </AccordionSummary>

      <AccordionDetails>
        <Typography>{cookie.content}</Typography>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = tss.create(() => ({
  root: {
    justifyContent: 'space-between'
  }
}));
